<template>
  <div class="data-pages dataList">
    <div class="p16">
      <p style="font-weight: bold;">会员预警</p>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box">
          <div class="boxs br10">
            <div class="flex-row pb16">
              <p class="titles mr10"><v-date :beginTime="query.beginTime" :endTime="query.endTime" :clearable="false" @time="change"></v-date></p>
              <el-select v-model="query.messageType" class="mr10" placeholder="消费项目">
                <el-option label="全部类型" value></el-option>
                <el-option label="充值预警" value="recharge"></el-option>
                <el-option label="消费预警" value="consume"></el-option>
                <el-option label="消费频次预警" value="consumeTotal"></el-option>
              </el-select>
              <el-button type="primary" @click="doData">搜索</el-button>
            </div>
            <el-table :data="list" :max-height="height - 250" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="memberName" label="会员姓名"></el-table-column>
              <el-table-column prop="mobile" label="手机号码"></el-table-column>
              <el-table-column prop="messageTypeCn" label="预警类型"></el-table-column>
              <el-table-column prop="remark" label="说明"></el-table-column>
              <el-table-column prop="createTime" label="预警时间">
                <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
              </el-table-column>
            
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  mixins: [minxin],
  data() {
    return {
      staffList: [],
      url: this.$url.memberMessageRecord.list,
      query: {
        messageType: "",
        beginTime: '',
        endTime: ''
      },
      height: this.$store.getters.MainHeight,
      totalCount: 0
    };
  },

  created () {
    let { monthStartDate } = this.getStartDay(new Date())
    this.query.beginTime = monthStartDate
    this.query.endTime = this.getCurrentDate()
    this.totalCounts();
  },
 
  methods: {
    totalCounts() {
      this.$api.post(this.$url.memberMessageRecord.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    change (value) {
      this.query.beginTime = value[0] ? this.formatDay(value[0]) : '';
      this.query.endTime = value[1] ? this.formatDay(value[1]) : '';
    }
  }
};
</script>
<style scoped lang="less">
</style>